import React from 'react';
import {Navigate} from 'react-router-dom';
import usePermissions from '../rbac/usePermissions';
import {firstAdminPath} from '../components/menu-components/AdminNavigation';
import AdminLayout from '../components/layouts/AdminLayout';

export default function AdminLanding(){
 const {can}=usePermissions(),path=firstAdminPath(can);
 return path?<Navigate to={path} replace/>:<AdminLayout><p role="alert">Нет доступных разделов. Обратитесь к администратору для настройки прав.</p></AdminLayout>;
}
